import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";

/** Password field with a show/hide (eye) toggle. Accepts the same props as <Input>. */
const PasswordInput = React.forwardRef(({ className = "", ...props }, ref) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={visible ? "text" : "password"} className={`pr-11 ${className}`} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        title={visible ? "Hide password" : "Show password"}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 h-8 w-8 rounded-md flex items-center justify-center text-[#5a6b7e] hover:text-[#0e7490] hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0e7490]"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
